exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * @license\n * Copyright Akveo. All Rights Reserved.\n * Licensed under the MIT License. See License.txt in the project root for license information.\n */\nul {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  list-style-type: none;\n  margin: 0; }\n  ul li {\n    cursor: pointer;\n    margin-bottom: -1px;\n    text-align: center; }\n    ul li.active a::before {\n      display: block; }\n    ul li a {\n      position: relative;\n      text-decoration: none;\n      display: inline-block; }\n      ul li a::before {\n        display: none;\n        position: absolute;\n        content: '';\n        width: 100%;\n        height: 6px;\n        border-radius: 3px;\n        bottom: -2px;\n        left: 0; }\n\n:host.full-width ul {\n  -ms-flex-pack: distribute;\n      justify-content: space-around; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/staging/FitRadioAdmin2/src/app/@nebular/theme/components/route-tabset/route-tabset.component.scss
// module id = ../../../../../src/app/@nebular/theme/components/route-tabset/route-tabset.component.scss
// module chunks = main